function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "#6682a5",
  strokeWidth: 1.5,
  fill: "#6682a5",
  d: "M8.063 3.813H16v10.375H8.063z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6682A5",
  d: "M6.297 2.114c-.392.207-.586.535-.587.999-.004.93.356 2.25.823 3.02l.164.269v2.237l-.53.546c-1.02 1.054-1.612 2.002-2.033 3.261a8.177 8.177 0 00-.404 1.985c-.07.776-.02 1.04.254 1.341.252.276.103.264 3.56.29l3.177.023.024 2.686.023 2.687.118.174c.064.095.2.231.302.302.161.113.228.129.545.129.317 0 .383-.016.545-.13a1.41 1.41 0 00.302-.302l.118-.173.023-2.686.024-2.687 3.18-.023 3.18-.024.2-.131c.414-.274.503-.572.432-1.431a8.225 8.225 0 00-.406-2.033c-.42-1.255-1.012-2.205-2.032-3.258l-.53-.546V6.402l.164-.27c.464-.763.824-2.08.824-3.01 0-.466-.192-.8-.574-.996-.17-.087-.35-.09-5.46-.088-4.722.002-5.3.01-5.426.076zM15.592 4.1c0 .244-.3.912-.548 1.217-.3.37-.299.357-.299 2.226 0 1.415.012 1.726.072 1.87.041.098.358.463.743.857.928.949 1.316 1.48 1.673 2.293.15.344.365 1.039.413 1.341l.03.18H5.791l.033-.223c.055-.371.338-1.185.57-1.635.33-.644.678-1.096 1.486-1.93.57-.588.749-.803.788-.945.033-.117.05-.784.05-1.832-.003-1.813-.007-1.844-.291-2.195-.253-.312-.554-.978-.554-1.224 0-.084.14-.087 3.859-.087s3.86.003 3.86.087z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6682a5",
  strokeWidth: 1.5,
  fill: "#6682a5",
  d: "M6.438 10.938h10.687v3.5H6.438z"
});

var SvgPinFilled = function SvgPinFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
};

export default SvgPinFilled;